import { Toggle } from "../Toggle"
import Select from "../Select"
import {
  BenchmarkTimeframe,
  BENCHMARK_TIMEFRAME_OPTIONS,
} from "~/ui-rtk/pages/WebMerchandising/types"

export interface BenchmarkControlsProps {
  /** Whether benchmarks are enabled */
  enabled: boolean
  /** Currently selected timeframe */
  timeframe: BenchmarkTimeframe
  /** Callback when toggle changes */
  onEnabledChange: (enabled: boolean) => void
  /** Callback when timeframe changes */
  onTimeframeChange: (timeframe: BenchmarkTimeframe) => void
}

/**
 * BenchmarkControls Component
 *
 * Controls for toggling benchmarks on/off and selecting the timeframe.
 * Placed near the DateRangePicker in the page header.
 *
 * Layout: Toggle with "Benchmarks" label, followed by timeframe dropdown.
 * Dropdown is disabled when toggle is off.
 */
export default function BenchmarkControls({
  enabled,
  timeframe,
  onEnabledChange,
  onTimeframeChange,
}: BenchmarkControlsProps) {
  const selectOptions = BENCHMARK_TIMEFRAME_OPTIONS.map(opt => ({
    label: opt.label,
    value: opt.value,
  }))

  return (
    <div className="flex items-center gap-3">
      {/* Toggle with label */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-system-gray-300">Benchmarks</span>
        <Toggle size="sm" value={enabled} onChange={onEnabledChange} />
      </div>

      {/* Timeframe dropdown */}
      <Select
        options={selectOptions}
        value={timeframe}
        onChange={e => onTimeframeChange(e.target.value as BenchmarkTimeframe)}
        disabled={!enabled}
        classes={{
          select:
            "min-w-[140px] bg-system-blue-800 border-system-blue-600 text-sm",
        }}
      />
    </div>
  )
}
